import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import store from "./store"; // progress bar style

function openLink(link, download = false) {
  const a = document.createElement("a");
  if (download) {
    a.setAttribute("download", "");
  }
  a.setAttribute("href", link);
  a.setAttribute("target", "_blank");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export async function configurePermissions() {
  NProgress.configure({ showSpinner: false }); // NProgress Configuration
  const { router } = await import("./router");

  router.beforeEach((to, from, next) => {
    NProgress.start(); // start progress bar
    if (to.redirectedFrom && to.redirectedFrom.startsWith("/open/")) {
      const portal = store.getters.portal;
      if (portal.slug === "grupogurgacz") {
        openLink("https://siscompliance.com/codigos-grupo-gurgacz");
      } else {
        openLink("https://www.siscompliance.com/codigo-pvax/");
      }
      next(false);
      NProgress.done(); // finish progress bar
    } else if (
      to.redirectedFrom &&
      to.redirectedFrom.startsWith("/download/")
    ) {
      const company = store.getters.company;
      const portal = store.getters.portal;
      const fileId = to.redirectedFrom.replace("/download/", "");
      const oldFile = company.compliance.oldFiles
        ? company.compliance.oldFiles[fileId]
        : false;
      const files = company.compliance.files;
      let link;
      if (files.length === 0 && oldFile) {
        link = `https://s3.siscompliance.com.br/${portal._id}/${oldFile}`;
      } else {
        const file = files.find((f) => f._id === fileId);
        link = `https://s3.siscompliance.com.br/${file.path}`;
      }
      openLink(link);

      next(false);
      NProgress.done(); // finish progress bar
    } else {
      next();
    }
  });

  router.afterEach(() => {
    NProgress.done(); // finish progress bar
  });
}
